import AxiosConfig from './LensAxiosConfig'
import firebase from '../config/FirebaseConfig'
import { createQuery } from '../../utils/filterUtils'

const create = async (lensPayload) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/lenses',
    lensPayload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

const getAll = async (query) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser
  const params = new URLSearchParams()

  if (query?.page) params.append('page', query.page)
  if (query?.limit) params.append('limit', query.limit)

  const { data } = await AxiosConfig.get(
    `/lenses?${params.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getAllSidebar = async () => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/folders',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const get = async (id) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/lenses/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const update = async (id, updatePayload) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.patch(
    `/lenses/${id}`,
    updatePayload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const createTWAccount = async (currency, timezone) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/tw',
    {
      currency,
      timezone
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getTWAccounts = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/tw',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getTWAccountsList = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/tw/accounts',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getTWSignInURL = async () => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/connections/tw/iframe',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getTWRedirect = async (internalTwAccountId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/tw/redirect?internal_tw_account_id=' + internalTwAccountId,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const deleteLens = async (id) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.delete(
    `/lenses/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getLensStatus = async (lensId) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(`/lenses/${lensId}/status`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getLensDiscoveryAds = async (lensId, nextId, filters) => {
  const { Aa: token } = firebase.auth().currentUser

  const params = {
    // Create the filters
    ...createQuery(filters),
    next: nextId
  }

  const { data } = await AxiosConfig.get(`/lenses/${lensId}/discovery`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getInsightByLens = async (lensId, dateQuery) => {
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    query: dateQuery ?? [
      [
        {
          key: 'event_date',
          value: 'last_7_days',
          operation: 'greater_than'
        },
        {
          key: 'event_date',
          value: 'today',
          operation: 'less_than'
        }
      ]
    ]
  }

  const { data } = await AxiosConfig.post(
    `/ads/insights/${lensId}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

// ============== Lens lighthouse ============== \\

const createLighthouseConfig = async (lensId, payload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    `/lenses/${lensId}/lighthouse/configurations`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const updateLighthouseConfig = async (lensId, configId, payload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.patch(
    `/lenses/${lensId}/lighthouse/configurations/${configId}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getLensLighthouseConfig = async (lensId) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/lenses/${lensId}/lighthouse/configurations`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getLensLighthouse = async (lensId, query) => {
  const { Aa: token } = firebase.auth().currentUser
  const { group, page, limit, sort, filters, currentWindow, selectedColumns } = query

  const payload = {
    metadata: {
      group_by: group,
      page,
      limit,
      sort,
      attr_window: currentWindow
    },
    query: filters,
    selected_columns: selectedColumns
  }

  const { data } = await AxiosConfig.post(
    `lenses/${lensId}/lighthouse`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getLensLighthouseChartData = async (lensId, query) => {
  const { Aa: token } = firebase.auth().currentUser
  const { group, page, limit, interval, sort, filters, currentWindow } = query

  console.log('sort value', sort)

  const payload = {
    metadata: {
      group_by: group,
      page,
      limit,
      interval,
      sort,
      attr_window: currentWindow
    },
    query: filters
  }

  const { data } = await AxiosConfig.post(
    `lenses/${lensId}/lighthouse/targets`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

export default {
  create,
  createTWAccount,
  deleteLens,
  get,
  getAll,
  getAllSidebar,
  getInsightByLens,
  getLensDiscoveryAds,
  getLensStatus,
  getTWAccounts,
  getTWAccountsList,
  getTWRedirect,
  getTWSignInURL,
  update,

  // Lighthouse
  Lighthouse: {
    getGroups: getLensLighthouse,
    createConfig: createLighthouseConfig,
    updateConfig: updateLighthouseConfig,
    getAllConfig: getLensLighthouseConfig,
    getChartData: getLensLighthouseChartData
  }
}
